export const EMPTY_ARRAY: readonly never[] = [];
